import React, { useContext, useEffect, useState } from 'react';
import classnames from 'classnames';
import PhoneInput2 from 'react-phone-input-2';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import CountryContext from '../../../context/country';
import { getCountries } from '../../forms/selects/SelectOptions';

import 'react-phone-input-2/lib/style.css';
import styles from './Form.module.css';

const PhoneInput = ({
  onChange,
  value = '',
  name,
  id,
  hasError,
  ...inputProps
}) => {
  const { t } = useTranslation();
  const [fieldValue, setFieldValue] = useState(value);
  const { activeRegion } = useSelector(state => ({
    activeRegion: state.i18n.region
  }));
  const { allowedCountries } = useContext(CountryContext);
  const preferredCountries = allowedCountries.map(entry =>
    entry.iso.toLowerCase()
  );

  const countryNames = getCountries(t).reduce((obj, entry) => {
    obj[entry.value] = entry.text;
    return obj;
  }, {});

  const handleChange = (phoneNumber, config, event) => {
    setFieldValue(phoneNumber);

    if (onChange) {
      onChange(event);
    }
  };

  useEffect(
    () => {
      setFieldValue(value);
    },
    [value]
  );

  return (
    <>
      <PhoneInput2
        inputProps={inputProps}
        country={activeRegion}
        value={fieldValue}
        onChange={handleChange}
        localization={countryNames}
        enableLongNumbers
        inputClass={classnames(styles.input, styles.phoneInput, {
          [styles.hasError]: hasError
        })}
        inputStyles={
          hasError
            ? {
                border: '1px solid #bd3500'
              }
            : {}
        }
        containerClass={styles.phoneContainer}
        preferredCountries={preferredCountries}
      />
      <input
        type="hidden"
        value={fieldValue ? `+${fieldValue}` : ''}
        name={name}
        id={id}
      />
    </>
  );
};

export default PhoneInput;
